import React from 'react';
import {UserPhoto} from "./style";
import {useDispatch, useSelector} from "react-redux";

const ProfileImage = () => {

    const dispatch = useDispatch();
    const {fullName, email} = useSelector(state => state.repository.user)

    return (
        <>
            <UserPhoto>
                <div className="divcenter user-image"></div>
                <h3 className="center pt-3 nomargin">{fullName}</h3>
                <h4 className="center">{email}</h4>

                <div className="line nomargin"/>
                <h5 className="pt-2">Description:</h5>
            </UserPhoto>
        </>
    );
};

export default ProfileImage;
